import { render, staticRenderFns } from "./NewYears_foodItem.vue?vue&type=template&id=3a0bd3cb&scoped=true"
import script from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
export * from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./NewYears_foodItem.vue?vue&type=style&index=0&id=3a0bd3cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bd3cb",
  null
  
)

export default component.exports